import { Component, Input, OnInit } from '@angular/core';
import { OnlineContentViewReportModel } from '@bayclubs/group-classes-employee-api';

@Component({
    selector: 'app-online-content-view-report-item',
    templateUrl: './online-content-view-report-item.component.html',
    styleUrls: ['./online-content-view-report-item.component.scss'],
    standalone: false
})
export class OnlineContentViewReportItemComponent implements OnInit {
    @Input()
    item: OnlineContentViewReportModel;
    constructor() {}

    ngOnInit() {}
}
